<template>
  <div :class="classes">
    <fieldset>
      <div
        :class="expandable ? 'cursor-pointer' : ''"
        class="flex items-center justify-between transition group"
        @click="handleClick()"
        @keydown="handleClick()"
      >
        <legend class="text-base font-medium text-neutral-900 transition group-hover:text-neutral-500 mr-auto">
          {{ label }}
        </legend>
        <fa
          v-if="expandable"
          :icon="arrowIcon"
          :class="arrowClass"
          class="text-lg transition group-hover:text-neutral-400 fa-fw rotates"
        />
      </div>
      <div
        v-if="isExpanded"
        class="mt-4 space-y-4"
      >
        <slot />
      </div>
    </fieldset>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faBone,
} from '@fortawesome/pro-light-svg-icons';

library.add({
  faAngleDown,
  faBone,
});

export default {
  name: 'VetsterSearchFacetGroup',

  props: {
    label: {
      type: String,
      default: undefined,
    },
    group: {
      type: String,
      default: undefined,
    },
    expanded: {
      type: Boolean,
      default: true,
    },
    expandable: {
      type: Boolean,
      default: true,
    },
    classes: {
      default: 'py-5 space-y-6 pr-0 sm:px-4',
      type: String,
    },
  },

  data() {
    return {
      open: true,
    };
  },

  computed: {
    arrowIcon() {
      return ['fal', 'angle-down'];
    },
    arrowClass() {
      return this.isExpanded && 'fa-rotate-180';
    },
    isExpanded() {
      return this.open;
    },
  },

  mounted() {
    if (!this.expanded) {
      this.open = false;
    }
  },

  methods: {
    handleClick() {
      if (this.expandable) {
        this.open = !this.open;
      }
    },
  },
};
</script>
